import * as React from "react"
import { Box } from "@mui/material";
import { translateCountryName } from "@ui-seeker/utils";

import { LabelCountry, LinkIconBlock, IconDataBlock } from "@components"
import { DATE_PERIODS } from "@constants";
import { commonFiltersValue, encodeCommonFiltersShareValue } from "@signals";


export default function infoColumn() {
    return [{
        name: 'market', label: 'Market',
        options: {
            display: 'excluded',
            customBodyRowRender: v => translateCountryName(v),
        }
    }, {
        name: "siteName", label: 'Retailer',
        options: {
            display: 'excluded',
            customBodyRowRender: (value, { market }) => <LabelCountry country={market} label={value}  />
        }
    }, {
        name: 'device', label: 'Device',
        options: { display: 'excluded' }
    }, {
        name: 'resourceType', label: 'Resource Type',
        options: {
            display: 'excluded',
        }
    }, {
        name: 'sectionName', label: 'Section',
        options: {
            display: 'excluded',
        }
    }, {
        name: 'siteName', label: 'Info',
        options: {
            filter: false,
            setCellHeaderProps: () => ({sx: { minWidth: 150 }}),
            customBodyRowRender: (value, row) => {

                const specificFilters = {
                    country: row.country,
                    retailer: [row.siteID],
                    company: [row.companyID],
                    brand: [row.brandID],
                    deviceID: row.deviceID,
                    skuGroup: null,
                    sku: row.skuID,
                    startDate: row.minDate,
                    endDate: row.maxDate,
                    currentPeriod: DATE_PERIODS.CUSTOM,
                    sectionCategory: [row.sectionCategoryID],
                    pageCategory: [row.pageCategoryID]
                }

                const shareURL = `/banners/details?sp=${(encodeCommonFiltersShareValue({...commonFiltersValue.value, ...specificFilters}))}&launch=true`;

                return <Box sx={{ whiteSpace: 'nowrap' }}>
                    <IconDataBlock icon='map-pin' value={<LinkIconBlock sx={{display: 'inline-block'}} url={row.sourceURL}>{row.resourceType}</LinkIconBlock>} />
                    <IconDataBlock icon='directions' value={<LinkIconBlock sx={{display: 'inline-block'}} url={row.sectionURL}>{row.sectionName}</LinkIconBlock>} />
                    <IconDataBlock icon='magnifying-glass-plus' value={<LinkIconBlock sx={{display: 'inline-block'}} url={shareURL} icon="up-right-from-square" target="">See Brand Banners Detail</LinkIconBlock>} />
                </Box>
            }
        }
    }, {
        name: 'tags', label: 'Tag',
        options: {
            display: 'excluded',
            customBodyRowRender: value => value.length ? value : 'Empty'
        }
    }]
}